import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        uid    : null,
        anon   : null,
        fb     : 'https://opensourcejobs-db.firebaseio.com/opensourcescores.json?auth=',
        mobile : false,
        assent : false
    },
    mutations: {
        uid( state, val ){ state.uid = val },
        anon( state, val ){ state.anon = val },
        mobile ( state, val ){ state.mobile = val },
        assent ( state, val ){ state.assent = !!val }
    },
    getters : {
        mobile ( state ) {
            return state.mobile
        }
    }
})
